import Box from "@mui/material/Box";
import { Tooltip } from "@mui/material";
import React from "react";

const COUNTRY_CODES: Record<string, string> = {
    argentina: "ar",
    australia: "au",
    austria: "at",
    belgium: "be",
    brazil: "br",
    bulgaria: "bg",
    canada: "ca",
    chile: "cl",
    china: "cn",
    colombia: "co",
    croatia: "hr",
    czechia: "cz",
    "czech republic": "cz",
    denmark: "dk",
    egypt: "eg",
    england: "gb-eng",
    estonia: "ee",
    finland: "fi",
    france: "fr",
    germany: "de",
    greece: "gr",
    "hong kong": "hk",
    hungary: "hu",
    iceland: "is",
    india: "in",
    indonesia: "id",
    ireland: "ie",
    israel: "il",
    italy: "it",
    japan: "jp",
    kazakhstan: "kz",
    korea: "kr",
    "korea, republic of": "kr",
    latvia: "lv",
    lithuania: "lt",
    malaysia: "my",
    mexico: "mx",
    morocco: "ma",
    netherlands: "nl",
    "new zealand": "nz",
    norway: "no",
    philippines: "ph",
    poland: "pl",
    portugal: "pt",
    romania: "ro",
    russia: "ru",
    "saudi arabia": "sa",
    scotland: "gb-sct",
    serbia: "rs",
    singapore: "sg",
    slovakia: "sk",
    slovenia: "si",
    "south africa": "za",
    "south korea": "kr",
    spain: "es",
    sweden: "se",
    switzerland: "ch",
    taiwan: "tw",
    thailand: "th",
    turkey: "tr",
    turkiye: "tr",
    türkiye: "tr",
    ukraine: "ua",
    "united arab emirates": "ae",
    "united kingdom": "gb",
    "united states": "us",
    uruguay: "uy",
    usa: "us",
    vietnam: "vn",
    wales: "gb-wls",
};

function countryCode(nationality?: string | null) {
    const value = (nationality || "").trim();
    if (!value) return null;
    if (/^[a-z]{2}(-[a-z]{2,4})?$/i.test(value)) return value.toLowerCase();
    return COUNTRY_CODES[value.toLowerCase()] || null;
}

export function nationalityFlagCode(nationality?: string | null) {
    return countryCode(nationality);
}

export function nationalityFlagSrc(nationality?: string | null, width = 640) {
    const code = countryCode(nationality);
    return code ? `https://flagcdn.com/w${width}/${code}.png` : null;
}

export default function NationalityFlag(props: { nationality?: string | null; height?: number; sx?: any }) {
    const code = countryCode(props.nationality);
    const height = props.height || 14;
    const width = Math.round(height * 1.5);
    if (!code || !props.nationality) return null;

    return (
        <Tooltip title={props.nationality} followCursor>
            <Box
                component="img"
                src={`https://flagcdn.com/w40/${code}.png`}
                srcSet={`https://flagcdn.com/w40/${code}.png 1x, https://flagcdn.com/w80/${code}.png 2x, https://flagcdn.com/w160/${code}.png 3x`}
                alt={props.nationality}
                sx={{
                    width,
                    height,
                    minWidth: width,
                    minHeight: height,
                    objectFit: "cover",
                    borderRadius: "2px",
                    flexShrink: 0,
                    ...props.sx,
                }}
            />
        </Tooltip>
    );
}
